import React, { useMemo } from 'react';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

import { green, red } from 'utils/color-styles';
import { getPasswordRequirements } from 'utils/password';

const ValidationRow = ({
  valid,
  message,
  colors,
}: {
  valid: boolean;
  message: string;
  colors: { valid: string; invalid: string };
}) => {
  const color = valid ? colors.valid : colors.invalid;
  const Icon = valid ? CheckIcon : CloseIcon;

  if (!message) {
    return null;
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div>
        <Icon style={{ color }} />
      </div>
      <Typography style={{ color, marginTop: 5, marginBottom: 5, marginLeft: 5 }}>
        {message}
      </Typography>
    </div>
  );
};

export const PasswordRequirements = ({
  password,
  userInputs = [],
}: {
  password: string;
  userInputs?: string[];
}) => {
  const userInputsSerialized = JSON.stringify(userInputs);
  const requirements = useMemo(
    () =>
      getPasswordRequirements(password, JSON.parse(userInputsSerialized) as string[]).filter(
        ({ message }) => !!message
      ),
    [password, userInputsSerialized]
  );

  return (
    <div>
      {requirements.map(({ message, validator }) => (
        <ValidationRow
          key={message}
          message={message}
          valid={validator(password, userInputs)}
          colors={{ valid: green, invalid: red }}
        />
      ))}
    </div>
  );
};
